import cx from 'classnames';
import { Edit } from 'education-icons';
import { AutoResizableTextarea, SymbolsCounter } from 'platform-components';
import React, { useState } from 'react';

import './quiz-editor__input.scss';

interface Props {
    placeholder?: string;
    onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
    onFocus?: React.FocusEventHandler<HTMLTextAreaElement>;
    onBlur?: React.FocusEventHandler<HTMLTextAreaElement>;
    maxLength: number;
    value: string;
    textareaClassname?: string;
    iconClassName?: string;
    counterClassName?: string;
    maxHeight?: number;
    readOnly?: boolean;
    inputRef?: React.MutableRefObject<HTMLTextAreaElement | null>;
}

export const QuizEditorInput = (props: Props) => {
    const {
        placeholder,
        onChange: handleChange,
        onFocus,
        onBlur,
        maxLength,
        value,
        textareaClassname,
        iconClassName,
        counterClassName,
        maxHeight,
        readOnly,
        inputRef,
    } = props;

    const [counterIsVisible, setCounterIsVisible] = useState<boolean>(false);

    const handleFocus = (event: React.FocusEvent<HTMLTextAreaElement>) => {
        if (readOnly) {
            return;
        }

        setCounterIsVisible(true);

        if (onFocus) {
            onFocus(event);
        }
    };

    const handleBlur = (event: React.FocusEvent<HTMLTextAreaElement>) => {
        if (readOnly) {
            return;
        }

        setCounterIsVisible(false);

        if (onBlur) {
            onBlur(event);
        }
    };

    return (
        <div className="quiz-editor__input">
            <AutoResizableTextarea
                maxHeight={maxHeight}
                maxLength={maxLength}
                mix={textareaClassname}
                onBlur={handleBlur}
                onChange={handleChange}
                onFocus={handleFocus}
                placeholder={placeholder}
                readOnly={readOnly}
                textareaRef={inputRef}
                value={value}
            />
            {!readOnly && (
                <>
                    <Edit className={cx('quiz-editor__edit-icon', iconClassName)} />
                    {counterIsVisible && (
                        <SymbolsCounter className={counterClassName} current={value.length} limit={maxLength} />
                    )}
                </>
            )}
        </div>
    );
};
